import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { FormattedDate, FormattedTime } from 'react-intl';
import { browserHistory } from 'react-router';
import { Card, CardMedia, CardText, CardTitle } from 'material-ui/Card';
import RaisedButton from 'material-ui/RaisedButton';
import Divider from 'material-ui/Divider';
import CancelIcon from 'material-ui/svg-icons/navigation/cancel';
import DetailView from '../Common/DetailView';

import AssetSegment from '../Asset/AssetSegment';
import EditIcon from 'material-ui/svg-icons/editor/mode-edit';
import SettingsIcon from 'material-ui/svg-icons/action/settings';
import PersonIcon from 'material-ui/svg-icons/social/person';
import TrainerIcon from 'material-ui/svg-icons/social/school';

import EventStore from '../../stores/EventStore';
import EventAssetStore from '../../stores/EventAssetStore';
import EventAttendeeStore from '../../stores/EventAttendeeStore';
import EventActions from '../../actions/EventActionCreator';
import ModuleActions from '../../actions/ModuleActionCreator';
import ModuleStore from '../../stores/ModuleStore';

import AttendanceSegment from './AttendanceSegment';
import AttendeeSegment from './AttendeeSegment';
import ModuleSegment from './EventModuleSegment'
import VenueSegment from '../Venue/VenueSegment';

import QRCode from 'qrcode.react';

import ROLES from '../../constants/Roles';
import buildContextMenu from '../Common/BuildContextMenu';
import { DateStyles } from '../../constants/CentricConstants';
import Error404 from '../Pages/Error404';
import { withMyUserId } from '../Common/Decorators';

class Event extends Component {

    constructor() {
        super(...arguments);
        this.state = {
            eventId: Number(this.props.routeParams.id),
            open: false,
            details: {
                name: '',
                description: '',
                capacity: 0,
                price: '',
                theme: '',
                image: '',
                displayGuests: 0,
                displayCapacity: 0,
                displayRemaining: 0,
                visibility: '',
                venue: '',
                venueId: '',
                status: '',
                timeRegistration: '',
                timeStart: '',
                timeEnd: '',
                dateStart: '',
                dateEnd: ''
            },
            guests: [],
            attendingByRole: null,
            actions: [],
            assets: [],
            myAttendance: {
                status: '',
            },

            links: {
                back: '/dashboard/events',
                edit: '',
            },

            actionsLoaded: false,
            moduleId: null
        };
    }

    componentDidMount() {
        this.onChange = this.onChange.bind(this);
        this.onDelete = this.onDelete.bind(this);
        this.onAttendanceChange = this.onAttendanceChange.bind(this);
        this.onAssetChange = this.onAssetChange.bind(this);
        this.addMyAttendance = this.addMyAttendance.bind(this);
        this.removeMyAttendance = this.removeMyAttendance.bind(this);
        this.onDeletePeriodicInstance = this.onDeletePeriodicInstance.bind(this);
        this.onDeletePeriodicWithFollowingInstances = this.onDeletePeriodicWithFollowingInstances.bind(this);
        this.onDeletePeriodicAllInstances = this.onDeletePeriodicAllInstances.bind(this);
        this.onModuleChange = this.onModuleChange.bind(this);

        this.listeners = [
            EventStore.addListener(this.onChange),
            EventAssetStore.addListener(this.onAssetChange),
            EventAttendeeStore.addListener(this.onAttendanceChange),
            ModuleStore.addListener(this.onModuleChange)
        ];
        EventActions.getById(this.state.eventId);
        EventActions.getAttendees(this.state.eventId);
        EventActions.listAssets(this.state.eventId);
        ModuleActions.getByEvent(this.state.eventId);

        this.setState({ actions: buildContextMenu(this.getActions(), this.context.auth) });
    }

    componentWillUnmount() {
        this.listeners.forEach( listener => listener.remove() );
    }

    render() {
        if (!!this.state.error) { return <Error404/>; }
        let timeStart = '';
        let timeEnd = '';
        let dateStartLong = '';
        let eventStartNumeric = ['0', '0'];
        let eventEndNumeric = ['0', '0'];

        if (this.state.details.timeStart.length) {
            dateStartLong = (
                <FormattedDate
                    value={this.state.details.timeStart}
                    {...DateStyles.long}
                />
            );

            const date = this.state.details.timeStart.split("+");
            const dateArray = date[0].split("T");
            eventStartNumeric[0] = dateArray[0].replace(/-/g, '');
            eventStartNumeric[1] = dateArray[1].replace(/:/g, '');

            timeStart = dateArray[1].slice(0,5);
        }

        if (this.state.details.timeEnd.length) {
            const date = this.state.details.timeEnd.split("+");
            const dateArray = date[0].split("T");
            eventEndNumeric[0] = dateArray[0].replace(/-/g, '');
            eventEndNumeric[1] = dateArray[1].replace(/:/g, '');

            timeEnd = dateArray[1].slice(0,5);
        }

        let displayQR;
        if (this.state.details.displayQR) {
            const QREvent = "BEGIN:VCALENDAR\n"+
                "BEGIN:VEVENT\n"+
                "DTSTART:"+eventStartNumeric[0]+"T"+eventStartNumeric[1]+"Z\n"+
                "DTEND:"+eventEndNumeric[0]+"T"+eventEndNumeric[1]+"Z\n"+
                "SUMMARY:"+ this.state.details.name+"\n"+
                "DESCRIPTION:"+this.state.details.description+"\n"+
                "LOCATION:"+this.state.details.venue+"\n"+
                "END:VEVENT\n"+
                "END:VCALENDAR\n";

            displayQR = (
                <Card className="cent-card ">
                    <CardText >
                        <QRCode value={QREvent} />
                    </CardText>
                </Card>
            );
        }

        const dateEnd = new Date(this.state.details.timeEnd);
        const expired = (dateEnd < new Date());
        const cardActions = [];

        let banner;
        const bannerContent = (<CardTitle title={this.state.details.name} subtitle={dateStartLong}/>);
        if (this.state.details.theme === 'None') {
            banner = (<div>{bannerContent}<Divider /></div>);
        } else {
            banner = (<CardMedia overlay={bannerContent} ><img src={this.state.details.image} /></CardMedia>);
        }

        if (this.state.details.status === 'active') {
            if (!expired) {
                switch (this.state.myAttendance.status) {
                    case 'waiting':
                        cardActions.push(
                            <RaisedButton
                                key="btn_cancel"
                                label="Cancel"
                                className="button-raised"
                                fullWidth={true}
                                onTouchTap={this.removeMyAttendance}
                            />
                        );
                        break;

                    case 'attending':
                        cardActions.push(
                            <RaisedButton
                                key="btn_cancel"
                                label="Cancel"
                                className="button-raised"
                                fullWidth={true}
                                onTouchTap={this.removeMyAttendance}
                            />
                        );
                        break;

                    default:
                        if (this.state.details.visibility === 'public') {
                            let canBook = true;
                            let canAttend = true;
                            const attending = this.state.guests.reduce((sum, {status, role}) => status === 'attending' && role === 'delegate' ? sum + 1 : sum, 0);
                            if (this.state.details.capacity > 0) {
                                canAttend = this.state.details.capacity > attending;
                            }
                            if (this.state.details.waitingListCapacity !== -1) {
                                if (this.state.details.capacity <= attending) {
                                    const waiting = this.state.guests.filter(({status}) => status === 'waiting').length;
                                    if (this.state.details.waitingListCapacity <= waiting) {
                                        canBook = false;
                                    }
                                }
                            }

                            if (canBook) {
                                cardActions.push(
                                    <RaisedButton
                                        key="btn_attend"
                                        label={canAttend  ? 'Attend' : 'Add to waiting list'}
                                        className="button-raised"
                                        secondary={true}
                                        fullWidth={true}
                                        onTouchTap={this.addMyAttendance}
                                    />
                                );
                            }
                        }
                        break;
                }
            }
        }

        return (
            <DetailView
                backButton={true}
                actions={this.state.actions}
            >
                <div className="cent-cards">
                    <div className="cent-flex-column cent-col-8">
                        <Card className="cent-card">
                            {banner}
                            <CardText>
                                <p>{timeStart} - {timeEnd}</p>
                                <p>{this.state.details.description}</p>
                            </CardText>
                        </Card>
                    </div>
                    <div className="cent-flex-column cent-col-4">
                        <AttendanceSegment
                            event={this.state.details}
                            myAttendance={this.state.myAttendance}
                            actions={cardActions}
                        />
                        <ModuleSegment eventId={this.state.eventId}/>
                        {!!this.state.details.venue && (
                            <VenueSegment
                                venue={{
                                    id: this.state.details.venueId,
                                    name: this.state.details.venue
                                }}
                                location={{
                                    id: this.state.details.locationId,
                                    name: this.state.details.location,
                                }}
                            />
                        )}
                        <AssetSegment assets={this.state.assets} />

                        {!!this.state.details.displayGuests && (
                            <AttendeeSegment guests={this.state.guests}/>
                        )}

                        {displayQR}
                    </div>
                </div>
            </DetailView>
        );
    }

    getActions() {
        return [
            {
                link: `/dashboard/event/${this.state.eventId}/attendees`,
                icon: <PersonIcon />,
                label: 'Attendance',
                condition: {
                    roles: [ROLES.ADMIN]
                }
            },
            {
                link: `/dashboard/event/${this.state.eventId}/trainers/`,
                icon: <TrainerIcon />,
                label: 'Trainers',
                condition: {
                    roles: [ROLES.ADMIN],
                }
            },
            {
                type: 'divider'
            },
            {
                link: `/dashboard/event/${this.state.eventId}/settings`,
                icon: <SettingsIcon />,
                label: 'Settings',
                condition: {
                    roles: [ROLES.ADMIN]
                }
            },
            {
                link: `/dashboard/event/${this.state.eventId}/edit`,
                icon: <EditIcon />,
                label: 'Edit',
                condition: {
                    roles: [ROLES.ADMIN]
                }
            },
            {
                type: 'deleteDialog',
                dialogType: 'menu',
                value: this.state.eventId,
                title: 'Delete event',
                deleteAction: this.onDelete,
                message: (<span>Are you sure to delete this event?</span>),
                condition: {
                    roles: [ROLES.ADMIN],
                    fields: {
                        periodic: [false]
                    }
                }
            },
            {
                type: 'deleteDialog',
                dialogType: 'menu',
                value: this.state.eventId,
                title: 'Delete periodic event',
                menuTitle: 'Delete this instance',
                deleteAction: this.onDeletePeriodicInstance,
                message: (<span>All other events in the series will be retained. Are you sure to delete this event?</span>),
                condition: {
                    roles: [ROLES.ADMIN],
                    fields: {
                        periodic: [true]
                    }
                }
            },
            {
                type: 'deleteDialog',
                dialogType: 'menu',
                value: this.state.eventId,
                title: 'Delete periodic event',
                menuTitle: 'Delete all the following',
                deleteAction: this.onDeletePeriodicWithFollowingInstances,
                message: (<span>This and all the following events will be deleted. Are you sure to delete this event?</span>),
                condition: {
                    roles: [ROLES.ADMIN],
                    fields: {
                        periodic: [true]
                    }
                }
            },
            {
                type: 'deleteDialog',
                dialogType: 'menu',
                value: this.state.eventId,
                title: 'Delete periodic event',
                menuTitle: 'Delete all events series',
                deleteAction: this.onDeletePeriodicAllInstances,
                message: (<span>All events in the series will be deleted. Are you sure to delete this event?</span>),
                condition: {
                    roles: [ROLES.ADMIN],
                    fields: {
                        periodic: [true]
                    }
                }
            },
            {
                type: 'divider'
            },
            {
                link: '/logout',
                icon: <CancelIcon />,
                label: 'Sign out',
            }
        ]
    }

    onChange() {
        try {
            const details = EventStore.getById(this.state.eventId);
            if (details !== undefined) {
                const actions = this.state.actionsLoaded ? this.state.actions : buildContextMenu(this.getActions(), this.context.auth, details);
                this.setState({ details, actions, actionsLoaded: true });
            }
        } catch (error) {
            if (!error.code) {
                throw error;
            } else {
                this.setState({error});
            }
        }
    }

    onDelete(eventId) {
        if (eventId === this.state.eventId) {
            EventActions.delete(eventId);
            browserHistory.replace(this.state.links.back);
        }
    }

    onAttendanceChange() {
        const guests = EventAttendeeStore.getEventGuests(this.state.eventId);
        const myAttendance = EventAttendeeStore.getDetails(this.state.eventId, this.context.auth.identity.id) || {};
        const attendingByRole = guests && guests.reduce((sum, guest) => guest.status !== 'attending' ? sum : ({...sum, [guest.role]: (sum[guest.role] || 0) + 1}), {});
        this.setState({myAttendance, guests, attendingByRole });
    }

    onAssetChange() {
        const assets = EventAssetStore.getByEvent(this.state.eventId);
        if (assets !== undefined) {
            this.setState({assets: assets});
        }
    }

    addMyAttendance() {
        if (!this.state.moduleId) {
            EventActions
                .addMyAttendance(this.state.eventId, this.context.auth.identity.id)
                .then(this.setState({details: {...this.state.details, attendeeCount: this.state.details.attendeeCount + 1}}));
        } else {
            ModuleActions
                .saveSubscription(this.state.moduleId, this.props.userId, { status: 'enrolled', eventId: this.state.eventId })
                .then(() => {
                    EventActions.getMyAttendance(this.state.eventId);
                    this.setState({details: {...this.state.details, attendeeCount: this.state.details.attendeeCount + 1}});
                });
        }
    }

    removeMyAttendance() {
        EventActions
            .removeMyAttendance(this.state.eventId, this.state.myAttendance)
            .then(this.setState({details: {...this.state.details, attendeeCount: this.state.details.attendeeCount - 1}}));
    }

    onDeletePeriodicInstance(eventId) {
        if (eventId === this.state.eventId) {
            EventActions.deletePeriodicInstance(eventId);
            browserHistory.replace(this.state.links.back);
        }
    }

    onDeletePeriodicWithFollowingInstances(eventId) {
        if (eventId === this.state.eventId) {
            EventActions.deletePeriodicWithFollowingInstances(eventId);
            browserHistory.replace(this.state.links.back);
        }
    }

    onDeletePeriodicAllInstances(eventId) {
        if (eventId === this.state.eventId) {
            EventActions.deletePeriodicAllInstances(eventId);
            browserHistory.replace(this.state.links.back);
        }
    }

    onModuleChange() {
        const module = ModuleStore.getByEvent(this.state.eventId);
        if (!!module) {
            this.setState({moduleId: module.id});
        }
    }
}

Event.contextTypes = {
    auth: PropTypes.shape({
        identity: PropTypes.shape({
            id: PropTypes.number.isRequired
        })
    }).isRequired
};

export default withMyUserId(Event);
